import { GOERLI } from '../types';
export default {
  type: GOERLI,
  service: 'myetherwallet.com',
  url: 'wss://ws.mewapi.io/goerli',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
